import type { MainContentMode } from "./layoutRegistry";

export interface LegacyMainContentContext {
  isGlobalPath: boolean;
  isFluidicDashboard: boolean;
  isBuildMode: boolean;
  isInteractMode: boolean;
  isConnectorDetailPath: boolean;
  isKnowledgeGraphPath: boolean;
  isWorkspacesPath: boolean;
  isHomePath: boolean;
  isStoryDetailPath: boolean;
}

export interface MainContentBehavior {
  hasGutter: boolean;
  overflowY: "auto" | "hidden";
  isFullWidth: boolean;
}

const MODE_BEHAVIORS: Record<MainContentMode, MainContentBehavior> = {
  centered: {
    hasGutter: true,
    overflowY: "auto",
    isFullWidth: false,
  },
  padded: {
    hasGutter: true,
    overflowY: "hidden",
    isFullWidth: true,
  },
  fullBleed: {
    hasGutter: false,
    overflowY: "hidden",
    isFullWidth: true,
  },
};

/**
 * Converts semantic route chrome into concrete wrapper behavior. Routes that
 * have not moved to the registry retain the exact pre-registry treatment.
 */
export const resolveMainContentBehavior = (
  mode: MainContentMode | undefined,
  legacy: LegacyMainContentContext,
): MainContentBehavior => {
  if (mode) return MODE_BEHAVIORS[mode];

  const ownsPageChrome =
    legacy.isKnowledgeGraphPath ||
    legacy.isWorkspacesPath ||
    legacy.isHomePath ||
    legacy.isStoryDetailPath;
  const clipsOverflow = legacy.isConnectorDetailPath || ownsPageChrome;
  const isFullWidth =
    legacy.isGlobalPath ||
    legacy.isFluidicDashboard ||
    legacy.isBuildMode ||
    legacy.isInteractMode ||
    legacy.isConnectorDetailPath ||
    ownsPageChrome;

  return {
    hasGutter: !ownsPageChrome,
    overflowY: clipsOverflow ? "hidden" : "auto",
    isFullWidth,
  };
};
